<template>
    <el-date-picker
        v-model="val"
        type="week"
        format="yyyy-MM-dd"
        placeholder="Seleccione una semana"
        :picker-options="{firstDayOfWeek:1}"
        @change="weekPickerChange">
    </el-date-picker>                
</template>

<script type="text/javascript">
    export default {
        props: ['value'],
        data() {
            // let val = (this.value != null) ? moment(this.value).add(1, 'days').toDate() : null;
            let val = (this.value != null) ? moment(this.value).toDate() : null;
            return {
                val: val,
            }
        },
        watch: {
            'value': function (value) {
                this.val = (value != null) ? moment(value).toDate() : null;
            }
        },
        methods: {
            weekPickerChange(value) {
                this.val = moment(value).subtract(1,'days');
                this.$emit('input', [moment(value).startOf('isoWeek').format('YYYY-MM-DD'), moment(value).endOf('isoWeek').format('YYYY-MM-DD')]);
            }
        }
    }
</script>